import { ResizeObserver } from '@juggle/resize-observer'

// @ts-ignore
window.ResizeObserver = ResizeObserver
